import { render, staticRenderFns } from "./ScrollToDiv.vue?vue&type=template&id=c36501fe&"
import script from "./ScrollToDiv.vue?vue&type=script&lang=js&"
export * from "./ScrollToDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c36501fe')) {
      api.createRecord('c36501fe', component.options)
    } else {
      api.reload('c36501fe', component.options)
    }
    module.hot.accept("./ScrollToDiv.vue?vue&type=template&id=c36501fe&", function () {
      api.rerender('c36501fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrJT3KKmu2fg/JS/comp/ScrollToDiv.vue"
export default component.exports